import { enableProdMode, importProvidersFrom } from '@angular/core';
import { provideEasTokenInterceptor } from '@rogers/self-serve-utils/eas-session-token';

import { createTranslateLoader } from './app/app.module';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { getCommonProviders, GlobalAppConfigService, SemafoneConfigService } from '@rci/self-serve-shared';
import { analyticsServiceFactory } from '@rci/self-serve-fido/core/analytics/analytics.service.factory';
import { FidoLoginStateService } from '@rci/self-serve-fido/core/fido-login-state/fido-login-state.service';
import { ResponseInterceptorService } from '@rci/self-serve-fido/core/http/response-interceptor.service';
import { AnalyticsStateService } from '@rci/self-serve-fido/core/analytics/analytics-state.service';
import { PdoConfigService } from '@rogers/self-serve-my-offers/pdo-config';
import { fidoConfigProvider, FidoConfigurations } from '@rci/self-serve-fido/app.config';
import { provideAnalyticsConfiguration, provideSelfServeAnalyticsService } from './app/core/analytics';
import { coreAnalyticsConfiguration } from './app/core/analytics/analytics-config/core-analytics-configuration';
import { secondaryNavAnalyticsConfiguration } from './app/core/secondary-nav/secondary-nav-analytics-config';
import { merge } from 'lodash';
import { LoaderService } from '@rogers/cdk/loader';
import { OidcInterceptor, oidcInterceptor } from '@rogers/self-serve-oidc-interceptor';
import { AppRoutingModule } from './app/app-routing.module';
import { AppStoreModule } from './app/state/app-store.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { ResponsiveModule } from '@rogers/ngx-responsive';
import { EAS_API_PATTERNS, EAS_SESSION_TOKEN_HEADER, RESPONSIVE_CONFIG } from './app/app.constant';
import { SharedModule } from './app/shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CDKCoreModule } from '@rogers/cdk/core';
import { CustomTileModule } from '@rogers/self-serve-utils/custom-tile';
import { AppComponent } from './app/app.component';
import { provideStore } from '@ngrx/store';

declare const __APP_BASE_HREF__: string;

// replaced by webpack.DefinePlugin
declare const __IS_PRODUCTION__: boolean;

if (__IS_PRODUCTION__) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideStore(),
    importProvidersFrom(
      AppRoutingModule,
      AppStoreModule,
      BrowserModule,
      ResponsiveModule.forRoot(RESPONSIVE_CONFIG),
      SharedModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      CDKCoreModule.forRoot({
        brand: 'fido',
      }),
      CustomTileModule.forRoot({ leftBorderColor: 'teal' }),
    ),
    {
      provide: APP_BASE_HREF,
      useValue: `${__APP_BASE_HREF__}`,
    },
    ...getCommonProviders({
      analyticsServiceFactory: analyticsServiceFactory,
      analyticsStateServiceClass: AnalyticsStateService,
      globalAppConfigServiceClass: GlobalAppConfigService,
      loginStateServiceClass: FidoLoginStateService,
      pdoConfigServiceClass: PdoConfigService,
      responseInterceptorServiceClass: ResponseInterceptorService,
      semafoneConfigServiceClass: SemafoneConfigService,
    }),
    { provide: FidoConfigurations, useValue: fidoConfigProvider },
    provideAnalyticsConfiguration(merge(coreAnalyticsConfiguration, secondaryNavAnalyticsConfiguration)),
    provideSelfServeAnalyticsService(),
    LoaderService,
    provideHttpClient(withInterceptorsFromDi()),
    ...provideEasTokenInterceptor({
      apiPatterns: EAS_API_PATTERNS,
      headerName: EAS_SESSION_TOKEN_HEADER,
    }),
    OidcInterceptor.configure(),
    oidcInterceptor,
    provideAnimations(),
  ],
}).catch(err => console.error(err));
